import { customFetch } from "@/client/custom-fetch";

import { TPlan, TPlanForBackend,TPlanUpdate } from "./plans.types";

// POST - Criar planos
export const createPlan = async (
  data: TPlanForBackend[],
  organizationId: string
): Promise<void> => {
  return customFetch<void>(`/organizations/${organizationId}/plans`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

// GET - Listar todos os planos da organização
export const getPlans = async (organizationId: string): Promise<TPlan[]> => {
  const result = await customFetch<TPlan[]>(`/organizations/${organizationId}/plans`, {
    method: "GET",
  });
  console.log("Plans fetched:", result);
  return result;
};

// GET - Obter um plano específico por ID
export const getPlanById = async (
  organizationId: string,
  planId: string
): Promise<TPlan> => {
  const result = await customFetch<TPlan>(
    `/organizations/${organizationId}/plans/${planId}`,
    {
      method: "GET",
    }
  );

  console.log("Plan fetched by ID:", result);
  return result;
};

export const updatePlan = async (
  organizationId: string,
  planId: string,
  data: TPlanUpdate
): Promise<TPlan> => {
  const bodyString = JSON.stringify(data);
  const result = await customFetch<TPlan>(
    `/organizations/${organizationId}/plans/${planId}`,
    {
      method: "PATCH",
      body: bodyString,
    }
  );

  return result;
};

export const deletePlan = async (
  organizationId: string,
  planId: string
): Promise<void> => {
  return customFetch<void>(`/organizations/${organizationId}/plans/${planId}`, {
    method: "DELETE",
  });
};
